module.exports = __webpack_public_path__ + "img/index-spot.1436f2cb.png";